module.exports = __webpack_public_path__ + "img/checkbox_fill.115bbc80.svg";